import type { TrialInfoResponse } from "src/api/interfaces/user";

/**
 * The disbursement trial is shut down, so every company is shown the inactive (ended) trial instead of a backend call.
 * `isUserOnTrial` stays false (status is not active); `isTrialInactive` / `hasConfigTrial` / `isTrialVisible` are true.
 * Dates are kept in the backend's "YYYY-MM-DD HH:mm:ss" format; `new Date()` of that is Invalid Date in Safari, which
 * today only feeds `isOldTrial` (false either way).
 */
export const INACTIVE_TRIAL_INFO: TrialInfoResponse = {
  transaction_status: "INACTIVE",
  started_at: "2024-02-12 14:49:16",
  expired_at: "2024-03-13 14:49:16",
  transaction_limit: { count: 0, max_count: 0, amount: 0, max_amount: 0 }
};
